/* import __COLOCATED_TEMPLATE__ from './images-uploader.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import UppyUploadMixin from "discourse/mixins/uppy-upload";
import discourseComputed from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
import TEMPLATE from "./images-uploader.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend(UppyUploadMixin, dt7948.p({
  type: "avatar",
  tagName: "span",
  uploadButtonText(uploadingOrProcessing) {
    return uploadingOrProcessing ? I18n.t("uploading") : I18n.t("upload");
  },
  validateUploadedFilesOptions() {
    return {
      imagesOnly: true
    };
  },
  uploadDone(upload) {
    this.done(upload);
  }
}, [["method", "uploadButtonText", [discourseComputed("uploadingOrProcessing")]]])));